export const PAGE_INCREMENT = "PAGE_INCREMENT"
export const PAGE_DECREMENT = "PAGE_DECREMENT"
export const UPDATE_VALID_FORM_DATA = "UPDATE_VALID_FORM_DATA"
export const UPDATE_FROM_GETDATA = "UPDATE_FROM_GETDATA"
export const UPDATE_FORM_IS_VALID = "UPDATE_FORM_IS_VALID"
export const PAGE_CLICKED_NEXT_UPDATE = "PAGE_CLICKED_NEXT_UPDATE"
export const CONTROL_LOADING = "CONTROL_LOADING"
export const CONTROL_EDIT_BENEFIT = "CONTROL_EDIT_BENEFIT"
export const UPDATE_UI_DATA = "UPDATE_UI_DATA"
export const SELECT_DOCUMENT = "SELECT_DOCUMENT"
export const RESET_SELECT_DOCUMENT = "RESET_SELECT_DOCUMENT"
export const ADD_FILE_TO_LIST = "ADD_FILE_TO_LIST"
export const REMOVE_FILE_FROM_LIST = "REMOVE_FILE_FROM_LIST"
export const CHECKBOX_STATUS_UPDATE = "CHECKBOX_STATUS_UPDATE"
export const CONTROL_DECLARATION = "CONTROL_DECLARATION"
export const EDIT_ALL_INVALID_FORM = "EDIT_ALL_INVALID_FORM"
export const EDIT_UPLOAD = "EDIT_UPLOAD"

export const pageIncrement = () => {
  return {
    type: PAGE_INCREMENT,
  }
}

export const pageDecrement = () => {
  return {
    type: PAGE_DECREMENT,
  }
}

export const updateValidFormData = (targetModal, newData) => {
  return {
    type: UPDATE_VALID_FORM_DATA,
    targetModal,
    newData,
  }
}

export const updateFromGetData = (targetModal, newData) => {
  return {
    type: UPDATE_FROM_GETDATA,
    targetModal,
    newData,
  }
}

export const updateFormIsValid = (formName, status) => {
  return {
    type: UPDATE_FORM_IS_VALID,
    formName,
    status,
  }
}

export const updateClickedNext = (currentPageNumber, changes) => {
  return {
    type: PAGE_CLICKED_NEXT_UPDATE,
    currentPageNumber,
    changes,
  }
}

export const controlLoading = () => {
  return {
    type: CONTROL_LOADING,
  }
}

export const updateUiData = (property, newData) => {
  return {
    type: UPDATE_UI_DATA,
    property,
    newData,
  }
}

export const selectDocument = (documentId, documentDesc) => {
  return {
    type: SELECT_DOCUMENT,
    documentId,
    documentDesc,
  }
}

export const resetSelectDocument = () => {
  return {
    type: RESET_SELECT_DOCUMENT,
  }
}

export const addFileToList = (
  fileName,
  documentId,
  filePath,
  fileSize,
  folderName,
  compressedFilesize
) => {
  return {
    type: ADD_FILE_TO_LIST,
    fileName,
    documentId,
    filePath,
    fileSize,
    folderName,
    compressedFilesize: compressedFilesize,
  }
}

export const removeFileFromList = (fileName, fileSize) => {
  return {
    type: REMOVE_FILE_FROM_LIST,
    fileName,
    fileSize,
  }
}

export const controlEditBenefit = formName => {
  return {
    type: CONTROL_EDIT_BENEFIT,
    formName,
  }
}

export const checkboxStatusUpdate = checkboxName => {
  return {
    type: CHECKBOX_STATUS_UPDATE,
    checkboxName,
  }
}

export const controlDeclaration = () => {
  return {
    type: CONTROL_DECLARATION,
  }
}

export const editAllInvalidForm = formlist => {
  return {
    type: EDIT_ALL_INVALID_FORM,
    formlist,
  }
}

export const editUpload = () => {
  return {
    type: EDIT_UPLOAD,
  }
}
